/** When the automatic publish runs. Pure. */
export const PORTAL_INTERVAL_MS = 15 * 60_000;
/** After a station event, wait this long so a burst of scans is one publish. */
export const PORTAL_EVENT_DELAY_MS = 60_000;
/** Never publish twice within this, however many events arrive. */
export const PORTAL_MIN_GAP_MS = 2 * 60_000;

export const portalDue = (now: number, lastRun: number): boolean => now - lastRun >= PORTAL_INTERVAL_MS;

/** Milliseconds until the next scheduled check (never negative). */
export const portalNextDelay = (now: number, lastRun: number): number =>
  Math.max(1_000, lastRun + PORTAL_INTERVAL_MS - now);

/** Delay before an event-driven publish, honouring the minimum gap since the last one. */
export const portalEventDelay = (now: number, lastRun: number): number =>
  Math.max(PORTAL_EVENT_DELAY_MS, lastRun + PORTAL_MIN_GAP_MS - now);
